import { Component, OnInit, ViewChild, Input, OnDestroy} from '@angular/core';
import { EditFilterData, EmployeeTypeList, FetchedData, FetchMarginData, FilterData, GridView, InputData, LocationList, MarginData, SaveMarginData } from '../../models/margin-modal';
import { MarginService } from '../../services/margincalc.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from 'src/app/modules/global/components/modals/confirmation-modal/confirmation-modal.component';
import { GlobalStoreService } from 'src/app/modules/global/services/global-store.service';
import { ConfirmationModalMarginComponent } from '../confirmation-modal-margin/confirmation-modal-margin.component';
import { Item } from 'src/app/modules/shared/dropdown/dropdown.models';
import { v4 } from 'uuid';
import { DropdownComponent } from 'src/app/modules/shared/dropdown/dropdown.component';
import { MarginCalcStoreService } from '../../services/margincalc-store.service';
import { SaveModalComponent } from '../save-modal/save-modal.component';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { threadId } from 'worker_threads';
import { ToastService } from 'src/app/modules/shared/toast/toast.service';


@Component({
  selector: 'MarginCalculatorApp-view',
  standalone: false,
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class MarginCalculatorViewComponent implements OnInit, OnDestroy {

  location: LocationList[];
  listcheck: string[];
  empTypeAll: EmployeeTypeList[];
  empType: EmployeeTypeList[];
  gridData: GridView[];
  gridDataAll: GridView[];
  secondaryData: GridView[];
  primarySkill: string='';
  userID: number;
  ctID: string;
  id:number=0;
  designation: string;
  selectedLocation: string;
  employType: string;
  bR: number;
  bR2: string;
  allocationPercentage: number;
  monGM: any = '-';
  monGMSubMargin:number;
  monGMAddMargin:number;
  monGmSubMargin:number;
  monGmAddMargin:number;
  empName: string;
  coverInMargin: boolean;
  tableCollection: InputData[] = [];
  fetchMarginData: FetchMarginData[] = [];
  saveMarginData: SaveMarginData[] = [];
  editMarginData: SaveMarginData[] = [];
  passcode: string = '';
  userLogedIn: string;
  fetchMarginResponse: FetchedData;
  totalMonGM: any;
  totalMonGmSubMargin:number;
  totalMonGmAddMargin:number;
  totalOnGM: any;
  totalOnGmSubMargin:number;
  totalOnGmAddMargin: number;
  totalOffGM: any;
  totalOffGmSubMargin: number;
  totalOffGmAddMargin: number;
  loading: boolean = false;
  employeeListFill:Item[]=[];
  showSaveButton : boolean = false;
  marginCalSub: Subscription;
  editMarginSub: Subscription;
  editFilterData: EditFilterData;
  dataEmitterSub: Subscription;
  gridName: string = '';
  gridStatus: Subscription;
  showOpen: boolean = false;
  fetchMarginDisable:boolean=false;
  LastUpdatedOn:string;

  public vh = window.innerHeight - 255;
  constructor(private service: MarginService, private modalService: NgbModal, private global: GlobalStoreService,
    public storeService: MarginCalcStoreService,private router:Router, private toastService: ToastService) {
  }
  @ViewChild('EmployeeDropdown') employeeNameDropdown: DropdownComponent;

  ngOnInit(): void {
    this.loading = true;
    this.dataEmitterSub = this.service.dataEmitter.subscribe((data: MarginData) => {
      this.LastUpdatedOn=data.LastUpdated[0].CreatedDate;
      this.location = data.Location;
      this.selectedLocation = this.location[0].Location;
      this.empTypeAll = data.EmployeeType;
      this.empType=this.selectedLocation=='Offshore'?this.empTypeAll.filter(x=>x.Emp_TypeAbbr==='E'||x.Emp_TypeAbbr==='C'):this.empTypeAll.filter(x=>x.Emp_TypeAbbr!=='E');
      this.gridDataAll = data.GridData;
      this.employType = this.selectedLocation=='Offshore'?this.empTypeAll[0].Emp_TypeAbbr:this.empTypeAll[2].Emp_TypeAbbr;
      this.allocationPercentage = 100;
      this.coverInMargin = true;
      this.loading = false;
      this.employeeListFiller(this.gridDataAll.filter(x=>x.Location==this.selectedLocation));
      this.coverInMargin = true;
      this.tableCollection = [];
      this.editMarginData = [];
      this.id = 0;
      this.addFieldValue();
      if(this.storeService.gridId !== undefined && this.storeService.gridId > 0) {
        this.editMarginSub = this.service.getMarginCalculatorGridById(this.storeService.gridId).subscribe((res) => {
          if(res.Message === 'Success') {
            this.editMarginData = res.MarginDataByID;
            this.tableCollection = [];
            this.id = 0;
            let j = this.editMarginData.length;
            for (let i = 0; i < j; i++) {
              this.tableCollection.push({
                Id:this.id,
                GridData: data.GridData,
                EmployeeList:this.employeeListFill,
                selectedLocation: this.editMarginData[i].Location,
                EMPName: this.editMarginData[i].EmployeeName,
                CTEmployeeID: this.editMarginData[i].Emp_CT_Id,
                EmmployeeTypeList:this.editMarginData[i].Location=='Offshore'?this.empTypeAll.filter
                (x=>x.Emp_TypeAbbr==='E'||x.Emp_TypeAbbr==='C'):this.empTypeAll.filter(x=>x.Emp_TypeAbbr!=='E'),
                UserID: this.editMarginData[i].UserID,
                employType: this.editMarginData[i].Emp_Type,
                primarySkill: this.editMarginData[i].Primary_Skills,
                designation: this.editMarginData[i].Emp_Level,
                bR: this.editMarginData[i].Billing_Rate,
                BillingRate:this.editMarginData[i].Billing_Rate.toFixed(1),
                allocationPercentage: this.editMarginData[i].Allocation,
                monGM: this.editMarginData[i].MonGM,
                monGMSubMargin: this.editMarginData[i].MonGMSubMargin,
                monGMAddMargin: this.editMarginData[i].MonGMAddMargin,
                coverInMargin: this.editMarginData[i].CoverInMargin
              });
              this.id++;
            }
            this.totalMonGM = this.editMarginData[0].TotalMonGM;
            this.totalMonGmSubMargin = this.editMarginData[0].TotalMonGMSubMargin;
            this.totalMonGmAddMargin = this.editMarginData[0].TotalMonGMAddMargin;

            this.totalOffGM = this.editMarginData[0].TotalOffGM;
            this.totalOffGmSubMargin = this.editMarginData[0].TotalMonGMSubMargin;
            this.totalOffGmAddMargin = this.editMarginData[0].TotalOffGMAddMargin;

            this.totalOnGM = this.editMarginData[0].TotalOnGM;
            this.totalOnGmSubMargin = this.editMarginData[0].TotalOnGMSubMargin;
            this.totalOnGmAddMargin = this.editMarginData[0].TotalOnGMAddMargin;

            this.gridName = this.editMarginData[0].GridName;
            this.editFilterData = {
              marketName: this.editMarginData[0].MarketName,
              accountName: this.editMarginData[0].AccountName,
              Onsite_Billable_Hrs: this.editMarginData[0].Onsite_Billable_Hrs,
              Offshore_Billable_Hrs: this.editMarginData[0].Offshore_Billable_Hrs
            }

            this.service.editMarginEmitter.emit(this.editFilterData);
            this.loading = false;
          }
          else {
            this.toastService.show(res.Message);
            this.loading = false;
          }
          this.showOpen = true;
        });
      }
      else {
        this.gridStatus = this.service.getMarginGridStatus().subscribe((res => {
          if(res.Status === '0') {
            this.showOpen = false;
          }
          else {
            this.showOpen = true;
          }
          this.loading = false;
        }));
      }
    });

    //Fetch margin Functionality and Validation
    this.marginCalSub = this.service.fetchMarginEmitter.subscribe((filterData: FilterData) => {
      this.storeService.filterData = filterData;
      this.userLogedIn = this.global.profile.EmployeeName;
      this.tableCollection.filter(x => x.coverInMargin == true)
      let j = this.tableCollection.length;
      if(j==1&&this.tableCollection[0].coverInMargin==false){
        this.tableCollection[0].monGM='-';
        this.totalOnGM='';
        this.totalOffGM='';
        this.totalMonGM='';
      }else{
        for (let i=0;i<j;i++){
          if(this.tableCollection[i].coverInMargin==false){
            this.tableCollection[i].monGM='-';
          }
      }

      }
      if (j == 0) {
        this.warningDialogs(j);
      }
      else {
        let n = 0;
        for (let i = 0; i < j; i++) {
          if (this.tableCollection[i].EMPName == undefined||this.tableCollection[i].EMPName == '') {
            n++;
            this.warningDialog1(i);
            break;
          }else if(this.tableCollection[i].bR==null){
            n++;
            this.warningDialog(i);
            break;
          }
        }
        if (n == 0) {
          for (let i = 0; i < j; i++) {
            if (this.tableCollection[i].coverInMargin) {
              this.fetchMarginData.push({
                Allocation: this.tableCollection[i].allocationPercentage,
                Billing_Rate: this.tableCollection[i].bR,
                Emp_CT_Id: this.tableCollection[i].CTEmployeeID,
                Emp_Level: this.tableCollection[i].designation,
                Emp_Type: this.tableCollection[i].employType,
                EmployeeName: this.tableCollection[i].EMPName,
                Location: this.tableCollection[i].selectedLocation,
                AccountName: filterData.SelectedAccountname,
                MarketName: filterData.SelectedMarket,
                Requested_By: filterData.SelectedRequestedBy,
                Offshore_Billable_Hrs: filterData.Offshore_Billable_Hrs,
                Onsite_Billable_Hrs: filterData.Onsite_Billable_Hrs,
                Primary_Skills: this.tableCollection[i].primarySkill,
                UserID: this.tableCollection[i].UserID,
                UserLoggedIn: this.userLogedIn
              });
            }
          }

          var requestdata = this.fetchMarginData;

          if (filterData.Passcode === ''||filterData.Passcode===undefined) {
            this.fetchMarginData = [];
            this.warningDialogPasss2();
          }
          else {
            this.fetchMarginData = [];
            if (filterData.Passcode !== undefined && filterData.Passcode !== ''){
            this.loading=true;
              this.service.getCalculateMargin(filterData.Passcode, requestdata).subscribe((res) => {
                this.fetchMarginResponse = res;
                if(this.fetchMarginResponse.FetchedDataRes.length==0){
                }
                else if (res.FetchedDataRes[0].Msg!='Success') {
                  this.warningDialogPasss();
                }
                else {
                  let l = this.fetchMarginResponse.FetchedDataRes.length;
                  for (let i = 0; i < l; i++) {
                    let uID = this.fetchMarginResponse.FetchedDataRes[i].UsersID;
                    let indx2 = this.tableCollection.findIndex(x => x.UserID == uID);
                    this.tableCollection[indx2].monGM = this.fetchMarginResponse.FetchedDataRes[i].SubMargin.toFixed(1)+' '+ '-'+' '+ this.fetchMarginResponse.FetchedDataRes[i].AddMargin.toFixed(1);
                    this.tableCollection[indx2].monGMSubMargin = this.fetchMarginResponse.FetchedDataRes[i].SubMargin;
                    this.tableCollection[indx2].monGMAddMargin= this.fetchMarginResponse.FetchedDataRes[i].AddMargin;

                  }
                  this.totalMonGM = this.fetchMarginResponse.FetchedDataRes[l - 1].TotalSubMargin.toFixed(1) +' '+ '-'+' ' + this.fetchMarginResponse.FetchedDataRes[l - 1].TotalAddMargin.toFixed(1);
                  this.totalMonGmSubMargin = this.fetchMarginResponse.FetchedDataRes[l - 1].TotalSubMargin;
                  this.totalMonGmAddMargin = this.fetchMarginResponse.FetchedDataRes[l - 1].TotalAddMargin;

                  this.totalOnGM = this.fetchMarginResponse.FetchedDataRes[l - 1].OnsiteSubMargin.toFixed(1)+' ' + '-' +' '+ this.fetchMarginResponse.FetchedDataRes[l - 1].OnsiteAddMargin.toFixed(1);
                  this.totalOnGmSubMargin = this.fetchMarginResponse.FetchedDataRes[l - 1].OnsiteSubMargin;

                  this.totalOnGmAddMargin =  this.fetchMarginResponse.FetchedDataRes[l - 1].OnsiteAddMargin;
                  this.totalOffGM = this.fetchMarginResponse.FetchedDataRes[l - 1].OffshoreSubMargin.toFixed(1)+' ' + '-'+' ' + this.fetchMarginResponse.FetchedDataRes[l - 1].OffshoreAddMargin.toFixed(1);
                  this.totalOffGmSubMargin = this.fetchMarginResponse.FetchedDataRes[l - 1].OffshoreSubMargin;
                  this.totalOffGmAddMargin = this.fetchMarginResponse.FetchedDataRes[l - 1].OffshoreAddMargin;
                  this.showSaveButton = true;
                }
                this.loading=false;
              });
             }
        }
        }
      }
    });
  }
  gridEmpNameEditFilter(item: InputData) {
    this.showSaveButton = false;
    let indx2 = this.tableCollection.findIndex(x => x == item);
    this.tableCollection[indx2].EmployeeList = [];
    this.tableCollection[indx2].EmmployeeTypeList = [];
    this.tableCollection[indx2].primarySkill = '';
    this.tableCollection[indx2].designation = '';
    this.tableCollection[indx2].EMPName = '';
    this.tableCollection[indx2].CTEmployeeID = '';
    this.tableCollection[indx2].UserID = null;
    this.tableCollection[indx2].bR = null;
    this.tableCollection[indx2].BillingRate = null;
    this.tableCollection[indx2].allocationPercentage = '100';
    this.tableCollection[indx2].monGM = '-';
    this.tableCollection[indx2].monGMSubMargin = null;
    this.tableCollection[indx2].monGMAddMargin = null;
    this.tableCollection[indx2].GridData = this.gridDataAll.filter(x => x.Location == item.selectedLocation);
    this.employeeListFill=[];
    this.employeeFilter(indx2);
    this.employeeNameDropdown.search="";
    this.tableCollection[indx2].EmmployeeTypeList=this.tableCollection[indx2].selectedLocation==='Offshore'?
    this.empTypeAll.filter(x=>x.Emp_TypeAbbr==='E'||x.Emp_TypeAbbr==='C'):this.empTypeAll.filter(x=>x.Emp_TypeAbbr!=='E');
    this.tableCollection[indx2].employType= this.tableCollection[indx2].selectedLocation==='Offshore'?
    this.tableCollection[indx2].EmmployeeTypeList[0].Emp_TypeAbbr:this.tableCollection[indx2].EmmployeeTypeList[1].Emp_TypeAbbr;
  }

  addFieldValue() {
    this.employeeListFill=[];
    this.tableCollection.unshift({
      Id:this.id,
      GridData: this.gridData,
      EmployeeList:this.employeeListFill,
      selectedLocation: this.selectedLocation,
      EMPName: this.empName,
      CTEmployeeID: this.ctID,
      EmmployeeTypeList:this.empType,
      UserID: this.userID,
      employType: this.employType,
      primarySkill: this.primarySkill,
      designation: this.designation,
      bR: this.bR,
      BillingRate:this.bR2,
      allocationPercentage: this.allocationPercentage,
      monGM: this.monGM,
      monGMSubMargin: this.monGMSubMargin,
      monGMAddMargin: this.monGMAddMargin,
      coverInMargin: this.coverInMargin,
    });
    this.employeeListFill=[];
    let indx2 = this.tableCollection.findIndex(x => x.Id == this.id);
    this.employeeFilter(indx2);
    this.id++;
    this.defaultValueAccessor();
    // this.employeeFilter();
    this.showSaveButton = false;
    this.fetchMarginDisable=false;
  }
  employeeListFiller(data:any){
    data.forEach((element,index) => {
      this.employeeListFill.push({
        uuid: v4(),
        id:1+index ,
        name:element.EMPName+'|'+element.CTEmployeeID,
        checked: false,
        visible: true
      });
     });
  }
  Select(item){
    let result:boolean;
    item.EMPName==''||item.EMPName==undefined||item.EMPName==null?result=true:result=false;
    return result;
  }


  employeeFilter(index?:number){
    if(index != null || index != undefined){
      this.tableCollection[index].GridData = this.gridDataAll.filter(loc => loc.Location == this.tableCollection[index].selectedLocation).filter((x) => {
        if(this.tableCollection[index].EMPName == x.EMPName && this.tableCollection[index].CTEmployeeID==x.CTEmployeeID){
          return true;
        }
        for (let j = 0; j < this.tableCollection.length; j++) {
          if (x.EMPName == this.tableCollection[j].EMPName && x.CTEmployeeID==this.tableCollection[j].CTEmployeeID) {
            return false;
          }
        }
        return true;
      })
      this.employeeListFiller(this.tableCollection[index].GridData);
      this.tableCollection[index].EmployeeList=this.employeeListFill;
    }
    for (let i = 0; i < this.tableCollection.length; i++) {
      this.tableCollection[i].GridData = this.gridDataAll.filter(loc => loc.Location == this.tableCollection[i].selectedLocation).filter((x) => {
        if(this.tableCollection[i].EMPName == x.EMPName){
          return true;
        }
        for (let j = 0; j < this.tableCollection.length; j++) {
          if (x.EMPName == this.tableCollection[j].EMPName && x.CTEmployeeID==this.tableCollection[j].CTEmployeeID) {
            return false;
          }
        }
        return true;
      })

      this.employeeListFill=[];
      this.employeeListFiller(this.tableCollection[i].GridData);
      this.tableCollection[i].EmployeeList=this.employeeListFill;
  }

  }
  defaultValueAccessor() {
    this.selectedLocation = this.location[0].Location;
    this.gridData = this.gridDataAll.filter(x => x.Location == this.selectedLocation);
    for (let i = 0; i < this.tableCollection.length; i++) {
      this.gridData = this.gridData.filter(x => x.EMPName != this.tableCollection[i].EMPName);
    }
    this.empName = '';
    this.ctID = '';
    this.employType = this.selectedLocation==='Offshore'?this.empTypeAll[0].Emp_TypeAbbr:this.empTypeAll[2].Emp_TypeAbbr;
    this.primarySkill = '';
    this.userID = null;
    this.designation = '';
    this.bR = null;
    this.bR2=null;
    this.allocationPercentage = 100;
    this.coverInMargin = true;
  }

  onEditChange({$event, item},item2:any) {
    let value1:string=item.name;
    let s=value1.indexOf('|');
    let value=value1.substring(0,s !=-1?s:value1.length);
    let ctid=value1.substring(s+1,value1.length);
    item2.EMPName=value;
    item2.CTEmployeeID=ctid;
    this.showSaveButton = false;
    let indx = this.gridDataAll.findIndex(x => x.EMPName == value&& x.CTEmployeeID==ctid);
    let secondaryData = this.gridDataAll[indx];
    let indx2 = this.tableCollection.findIndex(x => x.EMPName == value && x.CTEmployeeID==ctid);
    this.tableCollection[indx2].primarySkill = secondaryData.PrimarySkills;
    this.tableCollection[indx2].UserID = secondaryData.UserID;
    this.tableCollection[indx2].CTEmployeeID = secondaryData.CTEmployeeID;
    this.tableCollection[indx2].designation = secondaryData.Designation;
    this.tableCollection[indx2].bR = secondaryData.BR;
    this.tableCollection[indx2].BillingRate=secondaryData.BR!=null?secondaryData.BR.toFixed(1):undefined;
    this.tableCollection[indx2].monGM = '-';
    this.tableCollection[indx2].monGMSubMargin =null;
    this.tableCollection[indx2].monGMAddMargin =null;

    this.defaultValueAccessor();
    this.employeeFilter(indx2);
    this.employeeNameDropdown.search="";
  }
  onMarginButtonClick(){
    this. service.fetchmarginButtonEventEmitter.emit();
  }

  deleteaddFieldValue(item: InputData) {
      this.showSaveButton = false;
      this.tableCollection = this.tableCollection.filter(data => item.Id !== data.Id);
      let check=this.tableCollection.every(x=>x.coverInMargin===false);
      if(check){
        this.fetchMarginDisable=true;
      }else{
        this.fetchMarginDisable=false;
      }
  }

  confirmDialog(item: InputData) {
    if(this.tableCollection.length>1){
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
      backdrop: 'static'
    });
      modalRef.componentInstance.message = 'Are you sure you want to delete?';
      modalRef.result.then(result => result === 'Delete' ? (this.deleteaddFieldValue(item)) : null);
    }
  }

  allocationPercentageEditValidator(value: number, item: InputData) {
    this.showSaveButton = false;
    (value > 0 && value <= 110)&&(value%1===0) ? item.allocationPercentage = value : (item.allocationPercentage = 100, this.warningDialogAP());
  }
  warningDialogAP() {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please enter the value in between 1-110% and no decimal values are allowed';
  }

  bRValidatorEdit(value: number, item: InputData) {
    let name=item.EMPName;
    let indx = this.gridDataAll.findIndex(x => x.EMPName == name);
    if(indx!=-1){
    let secondaryData = this.gridDataAll[indx];
    let resetValue = secondaryData.BR;
    this.showSaveButton = false;
    let z = value;
    if(resetValue!=null){
    (value >= 15 && value <= 999.9) && (z.toString()).match(/^\d*\.?\d{0,1}$/g) ? (item.bR = value) : (item.bR = resetValue,item.BillingRate=resetValue.toFixed(1),this.warningDialogBR())
    }else{
      (value >= 15 && value <= 999.9) && (z.toString()).match(/^\d*\.?\d{0,1}$/g)?(item.bR=value):(item.bR=null,item.BillingRate=null,this.warningDialogBR())
    }
    }else{
      this.warningDialog1(indx);
      item.bR=null;
      item.BillingRate=null;
    }
  }

  warningDialogBR() {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Billing rate should be in between (15-999.9) and upto one decimal values are allowed';
  }

  warningDialog(value: number) {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please enter the value of Billing Rate';
  }

  warningDialog1(value: number) {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please select Employee Name';
  }

  warningDialogs(value: number) {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please add a row and enter all mandatory fields';
  }

  warningDialogPasss() {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please enter valid Passcode';
  }

  warningDialogPasss2() {
    const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.message = 'Please enter Passcode';
  }

  SaveAsMargCalc(type:string) {
    this.saveMarginData = [];
    let j = this.tableCollection.length;
    for (let i = 0; i < j; i++) {
      this.saveMarginData.push({
        Allocation: this.tableCollection[i].allocationPercentage,
        Billing_Rate: this.tableCollection[i].bR,
        Emp_CT_Id: this.tableCollection[i].CTEmployeeID,
        Emp_Level: this.tableCollection[i].designation,
        Emp_Type: this.tableCollection[i].employType,
        EmployeeName: this.tableCollection[i].EMPName,
        Location: this.tableCollection[i].selectedLocation,
        AccountName: this.storeService.filterData.SelectedAccountname,
        MarketName: this.storeService.filterData.SelectedMarket,
        Requested_By: this.storeService.filterData.SelectedRequestedBy,
        Offshore_Billable_Hrs: this.storeService.filterData.Offshore_Billable_Hrs,
        Onsite_Billable_Hrs: this.storeService.filterData.Onsite_Billable_Hrs,
        Primary_Skills: this.tableCollection[i].primarySkill,
        UserID: this.tableCollection[i].UserID,
        UserLoggedIn: this.userLogedIn,
        GridName: this.gridName,
        CoverInMargin: this.tableCollection[i].coverInMargin,
        MonGM: this.tableCollection[i].monGM,
        MonGMSubMargin: this.tableCollection[i].monGMSubMargin,
        MonGMAddMargin: this.tableCollection[i].monGMAddMargin,
        TotalMonGM: this.totalMonGM,
        TotalMonGMSubMargin: this.totalMonGmSubMargin,
        TotalMonGMAddMargin: this.totalMonGmAddMargin,
        TotalOnGM: this.totalOnGM,
        TotalOnGMSubMargin: this.totalOnGmSubMargin,
        TotalOnGMAddMargin: this.totalOnGmAddMargin,
        TotalOffGM: this.totalOffGM,
        TotalOffGMSubMargin: this.totalOffGmSubMargin,
        TotalOffGMAddMargin: this.totalOffGmAddMargin
      });
    }
    this.storeService.saveMarginData = this.saveMarginData;
    if(type==='save') {
      this.loading = true;
      this.service.saveMarginCalculator(this.storeService.gridId,this.storeService.saveMarginData).subscribe((res) => {
        if(res.Message === 'Success') {
          this.loading = false;
          this.toastService.show('Saved successfully');
          this.router.navigateByUrl('grid-data');
        }
        else {
          this.loading = false;
          this.toastService.show(res.Message);
        }

      });
    }
    else {
      const modalRef = this.modalService.open(SaveModalComponent, { centered: true });
    }
  }

  ChangeCoverInMargin() {
    this.showSaveButton = false;
    let check=this.tableCollection.every(x=>x.coverInMargin===false);
    if(check){
      this.fetchMarginDisable=true;
    }else{
      this.fetchMarginDisable=false;
    }

  }

  ChangeEmpType() {
    this.showSaveButton = false;
  }

  OpenGridNames() {
    //this.router.navigateByUrl('grid-data');
    let isDataEdited : boolean = false;
    if(this.editMarginData.length > 0) {
      if(this.editMarginData.length !== this.tableCollection.length) {
        isDataEdited = true;
      }
      else {
        let found:boolean = false;
        this.editMarginData.forEach((item,index) => {
          found = false;
          this.tableCollection.forEach((data,index2) => {
            if(!found) {
              if(item.Emp_CT_Id === data.CTEmployeeID) {
                found = true;
                if(item.Emp_Type !== data.employType || item.Primary_Skills !== data.primarySkill ||
                  item.Emp_Level !== data.designation || item.Location !== data.selectedLocation ||
                  item.Billing_Rate != data.bR || item.Allocation != data.allocationPercentage ||
                  item.CoverInMargin !== data.coverInMargin) {
                    isDataEdited = true;
                }
              }
            }
          });
          if(!found) {
            isDataEdited = true;
          }
        });
      }
      if(this.editMarginData[0].MarketName !== this.storeService.filterData.SelectedMarket || this.editMarginData[0].AccountName !== this.storeService.filterData.SelectedAccountname ||
        this.editMarginData[0].Offshore_Billable_Hrs != this.storeService.filterData.Offshore_Billable_Hrs || this.editMarginData[0].Onsite_Billable_Hrs != this.storeService.filterData.Onsite_Billable_Hrs) {
          isDataEdited = true;
      }
      if(isDataEdited) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, {
          centered: true,
          backdrop: 'static'
        });
        modalRef.componentInstance.message = 'You have unsaved changes. Do you want to continue?';
        modalRef.result.then(result => result === 'Delete' ? (this.router.navigateByUrl('grid-data')) : null);
      }
      else {
        this.router.navigateByUrl('grid-data');
      }
    }
    else {
      this.router.navigateByUrl('grid-data');
    }
  }

  redirectTo(uri:string){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
  }

  CancelGridNames() {
    this.storeService.gridId = 0;
    this.redirectTo('margin-calcuator');
  }

  ngOnDestroy() : void {
    if(this.dataEmitterSub) {
      this.dataEmitterSub.unsubscribe();
    }
    if(this.marginCalSub){
      this.marginCalSub.unsubscribe();
    }
    if(this.editMarginSub) {
      this.editMarginSub.unsubscribe();
    }
    if(this.gridStatus) {
      this.gridStatus.unsubscribe();
    }
  }

}

